var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0686 12.9324L9.00085 9.00012L5.0686 12.9324ZM12.9331 5.06787L9.0001 9.00012L12.9331 5.06787ZM9.0001 9.00012L5.0686 5.06787L9.0001 9.00012ZM9.00085 9.00012L12.9331 12.9324L9.00085 9.00012Z",
    fill: "#00793F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0686 12.9324L9.00085 9.00012L12.9331 12.9324M12.9331 5.06787L9.0001 9.00012L5.0686 5.06787",
    stroke: "#BA1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/rejected.1f3bd86f5865155618dc02b139bef43f.svg";
export { ForwardRef as ReactComponent };